import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '@/views/HomePage.vue'
import DashboardPage from '@/views/DashboardPage.vue'
import LoginPage from '@/views/LoginPage.vue'
import SignupPage from '@/views/SignupPage.vue'
import ReportsPage from '@/views/ReportsPage.vue'
import { useAuth } from '@/composables/useAuth'
import MobileHomePage from '@/views/MobileHomePage.vue' // 모바일 홈페이지
import MobileMeetingPage from '@/views/MobileMeetingPage.vue' // 모바일 회의 페이지
import { isMobile } from '@/utils/deviceDetection' // 모바일 디바이스 감지 함수
import MeetingRoom from '@/views/MeetingRoom.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomePage,
    beforeEnter: (to, from, next) => {
      // 루트 경로 접속 시 디바이스 감지하여 분기
      if (isMobile()) {
        // 모바일이면 MobileHomePage로 리다이렉트
        next('/mobile-dashboard')
      } else {
        // PC면 HomePage로 정상 진행
        next()
      }
    }
  },
  {
    path: '/mobile-dashboard',
    name: 'mobile-dashboard',
    component: MobileHomePage,
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: DashboardPage,
    meta: { requiresAuth: true },
    beforeEnter: (to, from, next) => {
      // PC 대시보드 접속 시 모바일이면 모바일 대시보드로 리다이렉트
      if (isMobile()) {
        next('/mobile-dashboard')
      } else {
        next()
      }
    }
  },
  {
    path: '/login',
    name: 'login',
    component: LoginPage
  },
  {
    path: '/signup',
    name: 'signup',
    component: SignupPage
  },
  {
    path: '/reports',
    name: 'Reports',
    component: ReportsPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/meeting/:meetingId',
    name: 'meeting-room',
    component: MeetingRoom,
    meta: {hideNavigation: true},
    beforeEnter: (to, from, next) => {
      if (isMobile()) {
        next('/mobile-dashboard');
      } else {
        next();
      }
    }
  },
  {
    path: '/mobile/meeting/:id',
    name: 'MobileMeeting',
    component: MobileMeetingPage,
    props: true
  }
]


const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const { isAuthenticated } = useAuth()
  const isDevelopmentBypass =
    process.env.NODE_ENV === 'development' && process.env.VUE_APP_BYPASS_AUTH === 'true'
  if (to.meta.requiresAuth && !isAuthenticated.value && !isDevelopmentBypass) {
    next('/login')
  } else {
    next()
  }
})

export default router